/**
 * 計助ダッシュボード用グラフ（すべてレガシー計助の KeisukeChart を流用）
 * - t検定・ANOVA: 棒グラフ（有意差マーク・細かい設定）
 * - 用量反応: 散布＋曲線（X軸対数可・細かい設定）
 * - 生存曲線: ステップ曲線（凡例・細かい設定）
 * 論文用のきれいなグラフが可能。
 */

import KeisukeDashboardChartRouter from './KeisukeDashboardChartRouter';
import styles from './KeisukeDashboardChart.module.scss';

interface KeisukeDashboardChartProps {
  isCalculating?: boolean;
}

export default function KeisukeDashboardChart({ isCalculating = false }: KeisukeDashboardChartProps) {
  return (
    <div className={`${styles.chartWrap} ${isCalculating ? styles.chartWrapCalculating : ''}`}>
      <KeisukeDashboardChartRouter layout="split-plot" isCalculating={isCalculating} />
    </div>
  );
}
